import React from "react";
import Line from "../../assets/Image/UnderLine-01.svg";
import Web3Pic from "../../assets/Image/Web3-01.png";

function Boots() {
  return (
    <div>
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div
            className="col-lg-8 col-md-12 col-sm-12 mt-5"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <h2 className="Text-heading text-center mt-5">
              Web3 Dubai Business Boost
            </h2>
            <div className="text-center">
              <img src={Line} className="img-fluid" alt="" width={"30%"} />
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12 mt-5"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="text-center">
              <img src={Web3Pic} className="img-fluid" width={"60%"} />
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12 mt-5 "
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="">
              <p
                className="text-detail mt-3"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                Experience the democratized realm of web3 that patches the gaps
                of Web2. Offering enhanced accessibility, data ownership, and
                heightened security, web3 signifies a high-potential future.
                Propel your success with Suffescom, a front-runner in web3
                development services in Dubai, and join the paradigm shift. Our
                team of proficient web3 developers in Dubai are adept in the
                latest technologies, including blockchain, AR/VR, and AI. We
                offer versatile solutions tailored to your specific needs.
                Catering to various sectors such as healthcare, education,
                finance, and more, we present innovative web3 solutions designed
                to elevate your business. Partner with us today and shape your
                business future in the world of web3.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Boots;
